#import "./PriceFull.graphql"
#import "./LocalizedStringFull.graphql"
#import "./ProductSizeLabelFull.graphql"

fragment OrderProductDetailFull on OrderProductDetail {
  id
  quantityFromWhichToProduceAtCentral
  producedOnePieceAtATime
  categoryIds
  permittedPickUpDates
  enablePermittedPickUpDates
  price {
    ...PriceFull
  }
  name {
    ...LocalizedStringFull
  }
  allergens
  description {
    ...LocalizedStringFull
  }
  sizeLabel {
    ...ProductSizeLabelFull
  }
}
